<template>
  <v-footer dark height="auto" color="primary darken">
    <v-layout align-center justify-space-between row fill-height>
      <v-btn v-for="(link, index) in siteIcons" :key="index + 'siteIcons' + _uid" class="mx-3" dark icon>
        <v-tooltip top>
          <v-icon size="24px" slot="activator">{{link.icon}}</v-icon>
          <span>{{link.title}}</span>
        </v-tooltip>
      </v-btn>
      <v-spacer/>
      <v-spacer/>
      <a v-for="(link, index) in socialIcons" :key="index + 'socialIcons' + _uid" :href="link.to" :target="link.target" class="footer-button-link">
        <v-btn class="mx-3" dark icon>
          <v-tooltip top>
            <v-icon size="24px" slot="activator">{{link.icon}}</v-icon>
            <span>{{link.title}}</span>
          </v-tooltip>
        </v-btn>
      </a>
    </v-layout>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',

  data () {
    return {
      siteIcons: [
        {
          title: 'Terms',
          to: { name: '' },
          icon: 'mdi-account-details',
          target: '_blank'
        },
        {
          title: 'Privacy',
          to: { name: '' },
          icon: 'mdi-account-badge-outline',
          target: '_blank'
        }
      ],
      socialIcons: [
        {
          title: 'Github',
          to: 'https://github.com/MatthewBooth',
          icon: 'mdi-github-circle',
          target: '_blank'
        },
        {
          title: 'LinkedIn',
          to: 'https://www.linkedin.com/in/mattboothdev',
          icon: 'mdi-linkedin-box',
          target: '_blank'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
  .footer {
    &-button {
      &-link {
        text-decoration: none;
      }
    }
  }
</style>
